import React, {
	memo,
	useCallback
} from 'react';

import { useAuthAction } from '../../contexts/AuthContext';
import { useUIAction } from '../../contexts/UIContext';

import UserProfile from './UserProfile';
import TextButton from '../Shared/TextButton';

import styles from './header.module.css';

import SupportModal from './SupportModal';

const Component = props => {
	const { signOut } = useAuthAction();
	const { setNavLock } = useUIAction();

	const handleSignOut = useCallback( () => {
		setNavLock( false );
		signOut();
	}, [
		setNavLock,
		signOut
	] );

	return (
		<>
			<ul className={ `${ styles.userMenu } no-print` } { ...props }>
				<li>
					<UserProfile />
				</li>
				<li>
					<span>&nbsp;|&nbsp;</span>
				</li>
				<li>
					<SupportModal />
				</li>
				<li>
					<span>&nbsp;|&nbsp;</span>
				</li>
				<li>
					<TextButton
						buttonText="Logout"
						onClick={ handleSignOut }
					/>
				</li>
			</ul>
		</>
	);
};

export default memo( Component );
